const crashGameIds = [
  '3',
  '7',
  '13',
  '14',
  '15',
  '16',
  '23',
  '27',
  '28',
  '29',
  '35',
  '38',
  '45',
  '46',
  '48',
  '51',
  '52',
  '63',
  '64',
  '65',
  '70',
  '75',
  '76',
  '78',
  '91',
  '93',
  '97',
  '98',
  '99',
  '102',
  '106',
  '107',
  '110',
  '111',
  '112',
];

const hiddenGameIds = ['78', '112', '76'];

export const isHiddenGame = (id: string) => hiddenGameIds.includes(id);

export const getTab = (id: string) => (crashGameIds.includes(id) ? ['crash'] : []);
